var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#E2E2E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5527_20078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8335 32.0833C29.2987 32.7053 29.8923 33.2199 30.5739 33.5923C31.2556 33.9647 32.0093 34.1862 32.784 34.2417C33.5588 34.2972 34.3364 34.1854 35.0641 33.9139C35.7919 33.6424 36.4527 33.2176 37.0018 32.6683L40.2518 29.4183C41.2385 28.3967 41.7845 27.0284 41.7721 25.6082C41.7598 24.188 41.1901 22.8294 40.1858 21.8251C39.1816 20.8208 37.823 20.2512 36.4028 20.2388C34.9825 20.2265 33.6143 20.7724 32.5927 21.7591L30.7293 23.6116",
    stroke: "black",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1664 29.9169C32.7012 29.2949 32.1076 28.7803 31.426 28.4079C30.7443 28.0355 29.9906 27.814 29.2159 27.7586C28.4411 27.7031 27.6635 27.8149 26.9358 28.0863C26.208 28.3578 25.5472 28.7826 24.9981 29.3319L21.7481 32.5819C20.7614 33.6035 20.2154 34.9718 20.2277 36.392C20.2401 37.8122 20.8098 39.1708 21.814 40.1751C22.8183 41.1794 24.1769 41.7491 25.5971 41.7614C27.0174 41.7737 28.3856 41.2278 29.4072 40.2411L31.2597 38.3886",
    stroke: "black",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 52,
    height: 52,
    rx: 26,
    stroke: "#F7F7F7",
    strokeWidth: 8.66667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5527_20078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareLink);
export default __webpack_public_path__ + "static/media/iconShareLink.6be39f428c9c91032f3a9a7421093dfb.svg";
export { ForwardRef as ReactComponent };